import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch, Link, Redirect } from "react-router-dom";
import { withRouter } from "react-router-dom";
import axios from "axios";

import { GlobalContext } from "../../app/providers/GlobalState";

import Navbar from "./Navbar/Navbar";

import UserDetalhe from "../../UserDetalhe/UserDetalhe";
import Utilizador from "../../UserDetalhe/UserInfo";

import ProfTurma from "../../UserDetalhe/User/Professor/Educacao/Educacao";
import ProfEnsinoEspecial from "../../UserDetalhe/User/Professor/EnsinoEspecial/EnsinoEspecial";
import ProfTurmaMatriculas from "../../UserDetalhe/User/Professor/Educacao/Matriculas/Matriculas";
import UserDadosGerais from "../../UserDetalhe/User/DadosGerais/DadosGerais";
import Drive from "../../UserDetalhe/User/Documentos/Documentos";
import PlayerFicheiro from "../../GerirCursos/Ficheiros/Pagina";

import GerirDetalheTurmaLayout from "../../GerirDetalheTurma/Layout";
import GerirMultisseriadoLayout from "../../GerirMultisseriado/Layout";
import GerirPlayer from "../../layout/roles/StaffLayout/PlayerLayout";
import GerirPlayerTurma from "../../layout/roles/StaffLayout/PlayerTurmaLayout";
import Player from "../../Player/PlayerLayout";
import MinhaConta from "../../Perfil/Conta/Main";
import AlterarPassword from "../../Perfil/AlterarPassword";
import AlterarLogin from "../../Perfil/AlterarLogin";
import UserConfiguracoes from "../../Perfil/Configuracoes";
import UserEstatisticas from "../../Perfil/Estatisticas/Main";
import Calendario from "../../features/Configs/Calendars/pages/CalendarPage";
import Tickets from "../../features/Tickets/Main";
import TicketsDetalhe from "../../features/Tickets/Detalhe/Main";
import TicketsNovo from "../../features/Tickets/Adicionar/Main";
import UnidadesOrganizacionais from "../../features/Configs/UnidadesOrganizacionais/Main";
import Empresa from "../../Gestao/Empresa/Main";
import Noticias from "../../features/CanalConfigs/Noticias/Noticias";
import Fotos from "../../features/CanalConfigs/Fotos/Fotos";
import Videos from "../../features/CanalConfigs/Videos/Videos";
import Carrossel from "../../features/CanalConfigs/Carrossel/Carrossel";
import Comentario from "../../features/CanalConfigs/Comentario/Comentario";
import Paginas from "../../features/CanalConfigs/Paginas/Main";
import GestaoFAQ from "../../features/CanalConfigs/FAQ/Main";
import GestaoTemplatesTurmas from "../../features/Configs/PlanosDeEstudo/pages/Turmas";
import GestaoTurmasOrganismos from "../../features/Turmas/CursosOrganismos";
import GestaoEnsinoEspecial from "../../features/Gestao/EnsinoEspecial/EnsinoEspecialPage";
import GestaoAgruparTurmas from "../../features/Turmas/Agrupar/Agrupar";
import GestaoVideoconferencias from "../../features/Gestao/Videoconferencias/Main";
import GestaoWebinar from "../../features/Configs/Webinar/Main";
import HabilidadesPage from "../../features/Configs/Habilidades/HabilidadesPage";
import GestaoTurmasInscricoes from "../../features/Turmas/CursosInscricoes";
import GestaoTurmaInscricoes from "../../features/Turmas/Inscricoes/Inscricoes";
import GestaoTurmasEstatisticas from "../../features/Turmas/CursosEstatisticas";
import GestaoCalendarioEscolar from "../../features/Configs/CalendarioEscolar/CalendarioEscolar";
import GestaoCalendarioEscolarDetalhe from "../../features/Configs/CalendarioEscolar/Detalhe";
import GestaoFichas from "../../features/Configs/Fichas/pages/Fichas";
import GestaoTurmasCategorias from "../../features/Configs/NiveisDeEnsino/pages/Categorias";
import GestaoCategoriasNoticia from "../../features/CanalConfigs/NoticiasCategorias/NoticiasCategorias";
import GestaoTurmasEdicoes from "../../features/Configs/Edicoes/pages/Edicoes";
import GestaoTurmasAnosLetivos from "../../features/Configs/AnosLetivos/pages/AnosLetivos";
import GestaoTurmasTurnos from "../../features/Configs/Turnos/pages/Turnos";
import GestaoTurmasTipoHoras from "../../features/Configs/TipoDeHoras/pages/TipoHoras";
import GestaoDiario from "../../features/Configs/EstruturasDeAvaliacao/pages/Diario";
import Transferencias from "../../features/Transferencias/Transferencias";
import TransferenciaAvaliacoes from "../../features/Transferencias/ImportarNotas/ImportarNotas";
import InserirNotas from "../../features/InserirNotas/InserirNotas";
import ColaboradoresTodos from "../../features/Usuarios/Todos";
import ColaboradoresSistemaInformacao from "../../features/Usuarios/SistemaInformacao";
import ColaboradoresSistemaInformacaoConsultar from "../../features/Usuarios/Consultar/Main";
import ColaboradoresSistemaInformacaoConsultarCreche from "../../features/Usuarios/Consultar/NotasCreche";
import ColaboradoresSistemaInformacaoConsultarPre from "../../features/Usuarios/Consultar/NotasPre";
import ColaboradoresSistemaInformacaoConsultarRegular from "../../features/Usuarios/Consultar/NotasRegular";
import ColaboradoresResultados from "../../features/Usuarios/CursosResultados";
import ColaboradoresDocumentacao from "../../features/Usuarios/Documentacao";
import ColaboradoresNovaMensagem from "../../features/Usuarios/NovaMensagem";
import ColaboradoresAssociar from "../../features/Usuarios/Associar";
import ColaboradoresAssociarAlunos from "../../features/Usuarios/AssociarAlunos";
import ColaboradoresPendentes from "../../features/Usuarios/Pendentes";
import ColaboradoresEstatisticas from "../../features/Usuarios/Estatisticas/Main";
import Turmas from "../../Perfil/Turmas";
import SistemaInformacao from "../../Perfil/SistemaInformacao";
import SistemaInformacaoConsultarNotas from "../../Perfil/Consultar/Main";
import SistemaInformacaoConsultarNotasCreche from "../../Perfil/Consultar/NotasCreche";
import SistemaInformacaoConsultarNotasPre from "../../Perfil/Consultar/NotasPre";
import SistemaInformacaoConsultarNotasRegular from "../../Perfil/Consultar/NotasRegular";
import PerfilQuestionario from "../../Perfil/QuestionarioSatisfacao/Questionario";
import PerfilRating from "../../Perfil/Rating";
import Ranking from "../../Perfil/CursosRanking";
import FormadoresListaCursos from "../../Perfil/Formador/Cursos";
import FormadoresListaTurmas from "../../Perfil/Formador/Turmas";
import FormadoresVideoconferencias from "../../features/Gestao/Videoconferencias/Main";
import FormadoresWebinars from "../../features/Configs/Webinar/Main";
import FormadoresCursosRanking from "../../Perfil/Formador/CursosRanking";
import FormadoresCursoResultados from "../../Perfil/Formador/CursosResultados";
import FormadoresCursosDisciplinaResultados from "../../Perfil/Formador/CursosDisciplinaResultados";
import FormadoresCursoEstatisticas from "../../Perfil/Formador/CursosEstatisticas";
import FormadoresCursoQuestionario from "../../Perfil/Formador/QuestionarioSatisfacao/Questionario";
import FormadoresListaCursoInscricoes from "../../Perfil/Formador/CursosInscricoes";
import Footer from "../../Geral/Footer";
import FAQ from "../../features/Faqs/FAQ";
import Popup from "../../features/Popup/Main";

class Layout extends Component {
    static contextType = GlobalContext;
    state = {
        redessociais: [],
        fundoBranco: false,
        //REDIRECT
        redirect: false,
        redirectLink: ""
    };

    UNSAFE_componentWillMount() {
        axios.interceptors.response.use(
            response => response,
            error => {
                if (error.response.status === 401) {
                    this.props.history.push("/login");
                }
                return Promise.reject(error);
            }
        );

        if (localStorage.getItem("accessToken"))
            axios.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem("accessToken")}`;

        this.validarSenha();
        this.entidadeRS();
    }

    componentDidUpdate() {
        if (this.context.atualizarEntidadeFooter) {
            this.entidadeRS();
            this.context.atualizarState({
                atualizarEntidadeFooter: false
            });
        }
    }

    validarSenha = () => {
        axios({
            method: "get",
            url: "/api/alterar-password/validar-senha"
        })
            .then(response => {
                if (!response.data.senhaValida) {
                    localStorage.removeItem("accessToken");
                    delete axios.defaults.headers.common.Authorization;
                    var link = "/login";
                    if (response.data.paginaPublica && response.data.loginSimplificado) link = `/${response.data.entidade}/login-escola`;
                    else link = `/${response.data.entidade}/login`;

                    this.setState({
                        redirect: true,
                        redirectLink: link
                    });
                }
            })
            .catch(() => {});
    };

    //VERIFICA SE O UTILIZADOR ESTÁ AUTENTICADO
    isAuthenticated = () => {
        axios({
            method: "get",
            url: "/api/anonimo/is-authenticated"
        })
            .then(response => {
                this.context.atualizarState({
                    is_authenticated: response.data.autenticado,
                    is_authenticated_nav: response.data.autenticado,
                    role: response.data.role
                });
            })
            .catch(() => {});
    };

    entidadeRS = () => {
        axios({
            method: "get",
            timeout: 60 * 10 * 1000,
            url: "/api/home-utilizador/entidade-rs"
        })
            .then(response => {
                this.setState({
                    redessociais: response.data
                });
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    render() {
        const {
            redessociais,
            fundoBranco,
            //REDIRECT
            redirect,
            redirectLink
        } = this.state;

        if (redirect) return <Redirect to={redirectLink} />;

        return (
            <div>
                <div className="background-layer" />
                <Navbar />
                <Switch>
                    <Route path="/gestao-utilizadores-detalhe/:code" component={UserDetalhe} />

                    <Route path="/utilizador" component={Utilizador} />
                    <Route path="/utilizador-turmas/:turma/matriculas" component={ProfTurmaMatriculas} />
                    <Route path="/utilizador-turmas" component={ProfTurma} />
                    <Route path="/utilizador-turmas-ensino-especial" component={ProfEnsinoEspecial} />
                    <Route path="/utilizador-dados-gerais" component={UserDadosGerais} />
                    <Route exact path="/utilizador-drive" component={Drive} />
                    <Route path="/utilizador-drive/player-ficheiro" component={PlayerFicheiro} />

                    <Route path="/detalhe/:code" component={UserDetalhe} />
                    <Route path="/faq" component={FAQ} />
                    <Route path="/turmas" component={Turmas} />
                    <Route path="/sistema-informacao/consultar/notas-creche" component={SistemaInformacaoConsultarNotasCreche} />
                    <Route path="/sistema-informacao/consultar/notas-pre" component={SistemaInformacaoConsultarNotasPre} />
                    <Route path="/sistema-informacao/consultar/notas-regular" component={SistemaInformacaoConsultarNotasRegular} />
                    <Route path="/sistema-informacao/consultar" component={SistemaInformacaoConsultarNotas} />
                    <Route path="/sistema-informacao" component={SistemaInformacao} />
                    <Route path="/sistema-informacao-questionario/:curso/player-questionario" component={PerfilQuestionario} />
                    <Route path="/sistema-informacao-avaliacao/:curso" component={PerfilRating} />
                    <Route path="/ranking" component={Ranking} />
                    <Route path="/formador-lista-cursos" component={FormadoresListaCursos} />
                    <Route path="/formador-lista-turmas" component={FormadoresListaTurmas} />
                    <Route path="/formador-videoconferencias" component={FormadoresVideoconferencias} />
                    <Route path="/formador-webinars" component={FormadoresWebinars} />
                    <Route path="/gestao-suporte" component={Tickets} />
                    <Route path="/gestao-suporte-detalhe" component={TicketsDetalhe} />
                    <Route path="/gestao-suporte-novo" component={TicketsNovo} />
                    <Route path="/administracao-suporte" component={Tickets} />
                    <Route path="/administracao-suporte-detalhe" component={TicketsDetalhe} />
                    <Route path="/administracao-suporte-novo" component={TicketsNovo} />
                    <Route path="/calendario" component={Calendario} />
                    <Route path="/user-suporte" component={Tickets} />
                    <Route path="/user-suporte-detalhe" component={TicketsDetalhe} />
                    <Route path="/user-suporte-novo" component={TicketsNovo} />
                    <Route path="/user-minha-conta" component={MinhaConta} />
                    <Route path="/user-alterar-senha" component={AlterarPassword} />
                    <Route path="/user-alterar-login" component={AlterarLogin} />
                    <Route path="/user-configuracoes" component={UserConfiguracoes} />
                    <Route path="/user-estatisticas" component={UserEstatisticas} />
                    <Route path="/gestao-unidades-organizacionais" component={UnidadesOrganizacionais} />
                    <Route path="/gestao-conta" component={Empresa} />
                    <Route path="/gestao-noticias" component={Noticias} />

                    <Route path="/gestao-fotos" component={Fotos} />
                    <Route path="/gestao-videos" component={Videos} />
                    <Route path="/gestao-carrossel" component={Carrossel} />
                    <Route path="/gestao-comentario" component={Comentario} />

                    <Route path="/gestao-paginas" component={Paginas} />
                    <Route path="/gestao-faq" component={GestaoFAQ} />
                    <Route path="/gestao-turmas" component={GestaoTurmasOrganismos} />
                    <Route path="/gestao-ensino-especial" component={GestaoEnsinoEspecial} />
                    <Route path="/gestao-templates-turmas" component={GestaoTemplatesTurmas} />
                    <Route path="/gestao-agrupar-turmas/:code" component={GestaoAgruparTurmas} />
                    <Route path="/gestao-videoconferencias" component={GestaoVideoconferencias} />
                    <Route path="/gestao-webinars" component={GestaoWebinar} />
                    <Route path="/Configs/Habilidades" component={HabilidadesPage} />
                    <Route path="/:curso/gestao-turmas-inscricoes" component={GestaoTurmasInscricoes} />
                    <Route path="/:curso/gestao-turma-inscricoes" component={GestaoTurmaInscricoes} />
                    <Route path="/:curso/gestao-turmas-estatisticas" component={GestaoTurmasEstatisticas} />
                    <Route path="/gestao-turmas-categorias" component={GestaoTurmasCategorias} />
                    <Route path="/gestao-fichas" component={GestaoFichas} />
                    <Route path="/gestao-calendarios-escolares" component={GestaoCalendarioEscolar} />
                    <Route path="/gestao-calendarios-escolares-detalhe/:code" component={GestaoCalendarioEscolarDetalhe} />
                    <Route path="/gestao-categoria-noticias" component={GestaoCategoriasNoticia} />
                    <Route path="/gestao-turmas-edicoes" component={GestaoTurmasEdicoes} />
                    <Route path="/gestao-turmas-anos-letivos" component={GestaoTurmasAnosLetivos} />
                    <Route path="/gestao-turmas-turnos" component={GestaoTurmasTurnos} />
                    <Route path="/gestao-turmas-tipo-horas" component={GestaoTurmasTipoHoras} />
                    <Route path="/gestao-diario" component={GestaoDiario} />
                    <Route exact path="/gestao-utilizadores-todos/novo-ticket/:tipo" component={ColaboradoresNovaMensagem} />
                    <Route exact path="/transferencias" component={Transferencias} />
                    <Route exact path="/transferencias/importar-notas" component={TransferenciaAvaliacoes} />
                    <Route exact path="/inserir-notas-manualmente" component={InserirNotas} />
                    <Route exact path="/gestao-utilizadores-todos" component={ColaboradoresTodos} />
                    <Route
                        exact
                        path="/gestao-utilizadores-sistema-informacao/consultar-notas-creche/:utilizador"
                        component={ColaboradoresSistemaInformacaoConsultarCreche}
                    />
                    <Route
                        exact
                        path="/gestao-utilizadores-sistema-informacao/consultar-notas-pre/:utilizador"
                        component={ColaboradoresSistemaInformacaoConsultarPre}
                    />
                    <Route
                        exact
                        path="/gestao-utilizadores-sistema-informacao/consultar-notas-regular/:utilizador"
                        component={ColaboradoresSistemaInformacaoConsultarRegular}
                    />
                    <Route
                        exact
                        path="/gestao-utilizadores-sistema-informacao/consultar/:utilizador"
                        component={ColaboradoresSistemaInformacaoConsultar}
                    />
                    <Route exact path="/gestao-utilizadores-sistema-informacao/:utilizador" component={ColaboradoresSistemaInformacao} />
                    <Route exact path="/gestao-utilizadores-resultados/:utilizador" component={ColaboradoresResultados} />
                    <Route exact path="/gestao-utilizadores-documentacao/:utilizador" component={ColaboradoresDocumentacao} />
                    <Route exact path="/gestao-utilizadores-associar" component={ColaboradoresAssociar} />
                    <Route exact path="/gestao-associar-alunos" component={ColaboradoresAssociarAlunos} />
                    <Route exact path="/gestao-utilizadores-pendentes" component={ColaboradoresPendentes} />
                    <Route exact path="/gestao-utilizadores-estatisticas" component={ColaboradoresEstatisticas} />
                    <Route path="/:curso/formador-lista-cursos/inscricoes" component={FormadoresListaCursoInscricoes} />
                    <Route exact path="/gerir-detalhe-turma/:turma/:pagina/:code" component={GerirDetalheTurmaLayout} />
                    <Route exact path="/gerir-detalhe-turma/:turma/:pagina" component={GerirDetalheTurmaLayout} />
                    <Route exact path="/gerir-multisseriado/:turma/:pagina/:code" component={GerirMultisseriadoLayout} />
                    <Route exact path="/gerir-multisseriado/:turma/:pagina" component={GerirMultisseriadoLayout} />
                    {/* <Route exact path="/detalhe-turma/:turma/:pagina" component={TurmasLayout} /> */}
                    <Route path="/:curso/formador-lista-cursos/ranking" component={FormadoresCursosRanking} />
                    <Route path="/:curso/formador-lista-cursos/resultados" component={FormadoresCursoResultados} />
                    <Route
                        path="/:curso/formador-lista-cursos/resultados-curso-disciplinas"
                        component={FormadoresCursosDisciplinaResultados}
                    />
                    <Route path="/:curso/formador-lista-cursos/estatisticas" component={FormadoresCursoEstatisticas} />
                    <Route path="/:curso/formador-lista-cursos/player-questionario" component={FormadoresCursoQuestionario} />

                    {/***************ROUTING PLAYERS TURMA GESTAO/INSTRUTOR***************/}
                    <Route path="/turma-player/:curso/:aula/player-videoconferencia" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-video" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-audio" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-pagina" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-pdf" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-questionario-dirigido" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-questionario-dirigido-resumo" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-questionario" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-questionario-resumo" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-questionario-resolucao" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-avaliacao" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-avaliacao-resumo" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-avaliacao-resolucao" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-questionario-progresso" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-questionario-progresso-resumo" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-questionario-progresso-resolucao" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-download" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-trabalho" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-link" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-sumario" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-sessao-presencial" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:aula/player-assiduidade" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:ficheiro/player-trabalho-ficheiro" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:ficheiro/player-ficheiro" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/:ficheiro/player-editor" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/vconf/:vconfid/player-videoconferencia" component={GerirPlayerTurma} />
                    <Route path="/turma-player/:curso/vconf/:vconfid/player-video" component={GerirPlayerTurma} />
                    {/***************ROUTING PLAYERS TURMA GESTAO/INSTRUTOR***************/}

                    {/***************ROUTING PLAYERS GESTAO/INSTRUTOR***************/}
                    <Route path="/gerir-curso/:curso/:aula/player-videoconferencia" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-video" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-audio" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-pagina" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-pdf" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-questionario-dirigido" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-questionario-dirigido-resumo" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-questionario" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-questionario-resumo" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-questionario-resolucao" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-avaliacao" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-avaliacao-resumo" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-avaliacao-resolucao" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-questionario-progresso" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-questionario-progresso-resumo" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-questionario-progresso-resolucao" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-download" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-trabalho" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-link" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-sumario" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-sessao-presencial" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:aula/player-assiduidade" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:ficheiro/player-trabalho-ficheiro" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:ficheiro/player-ficheiro" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/:ficheiro/player-editor" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/vconf/:vconfid/player-videoconferencia" component={GerirPlayer} />
                    <Route path="/gerir-curso/:curso/vconf/:vconfid/player-video" component={GerirPlayer} />
                    <Route path="/gestao-videoconferencia/:vconfid/player-videoconferencia" component={GerirPlayer} />
                    <Route path="/gestao-webinar/:vconfid/player-webinar" component={GerirPlayer} />
                    <Route path="/gestao-videoconferencia/:vconfid/player-video" component={GerirPlayer} />
                    <Route path="/gestao-videoconferencia/:vconfid/player-video-meets" component={GerirPlayer} />
                    <Route path="/gestao-webinar/:vconfid/player-video" component={GerirPlayer} />
                    <Route path="/gestao-webinar/:vconfid/player-video-meets" component={GerirPlayer} />
                    {/***************ROUTING PLAYERS GESTAO/INSTRUTOR***************/}

                    {/***************ROUTING PLAYERS***************/}
                    <Route path="/curso/:curso/:aula/player-videoconferencia" component={Player} />
                    <Route path="/curso/:curso/:aula/player-video" component={Player} />
                    <Route path="/curso/:curso/:aula/player-audio" component={Player} />
                    <Route path="/curso/:curso/:aula/player-pagina" component={Player} />
                    <Route path="/curso/:curso/:aula/player-pdf" component={Player} />
                    <Route path="/curso/:curso/:aula/player-questionario-dirigido" component={Player} />
                    <Route path="/curso/:curso/:aula/player-questionario-dirigido-resumo" component={Player} />
                    <Route path="/curso/:curso/:aula/player-questionario" component={Player} />
                    <Route path="/curso/:curso/:aula/player-questionario-resumo" component={Player} />
                    <Route path="/curso/:curso/:aula/player-questionario-resolucao" component={Player} />
                    <Route path="/curso/:curso/:aula/player-avaliacao" component={Player} />
                    <Route path="/curso/:curso/:aula/player-avaliacao-resumo" component={Player} />
                    <Route path="/curso/:curso/:aula/player-avaliacao-resolucao" component={Player} />
                    <Route path="/curso/:curso/:aula/player-questionario-progresso" component={Player} />
                    <Route path="/curso/:curso/:aula/player-questionario-progresso-resumo" component={Player} />
                    <Route path="/curso/:curso/:aula/player-questionario-progresso-resolucao" component={Player} />
                    <Route path="/curso/:curso/:aula/player-download" component={Player} />
                    <Route path="/curso/:curso/:aula/player-trabalho" component={Player} />
                    <Route path="/curso/:curso/:aula/player-link" component={Player} />
                    <Route path="/curso/:curso/:aula/player-sumario" component={Player} />
                    <Route path="/curso/:curso/:aula/player-sessao-presencial" component={Player} />
                    <Route path="/curso/:curso/:ficheiro/player-trabalho-ficheiro" component={Player} />
                    <Route path="/curso/:curso/:ficheiro/player-ficheiro" component={Player} />
                    <Route path="/curso/:curso/vconf/:vconfid/player-videoconferencia" component={Player} />
                    <Route path="/curso/:curso/vconf/:vconfid/player-videoconferencia-aguardar" component={Player} />
                    <Route path="/curso/:curso/vconf/:vconfid/player-video" component={Player} />
                    <Route path="/curso/:curso/vconf/:vconfid/player-video-meets" component={Player} />
                    {/***************ROUTING PLAYERS***************/}

                    {/***************ROUTING PLAYERS***************/}
                    <Route path="/detalhe-turma/:turma/:aula/player-videoconferencia" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-video" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-audio" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-pagina" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-pdf" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-questionario-dirigido" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-questionario-dirigido-resumo" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-questionario" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-questionario-resumo" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-questionario-resolucao" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-avaliacao" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-avaliacao-resumo" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-avaliacao-resolucao" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-questionario-progresso" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-questionario-progresso-resumo" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-questionario-progresso-resolucao" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-download" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-trabalho" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-link" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-sumario" component={Player} />
                    <Route path="/detalhe-turma/:turma/:aula/player-sessao-presencial" component={Player} />
                    <Route path="/detalhe-turma/:turma/:ficheiro/player-trabalho-ficheiro" component={Player} />
                    <Route path="/detalhe-turma/:turma/:ficheiro/player-ficheiro" component={Player} />
                    <Route path="/detalhe-turma/:turma/vconf/:vconfid/player-videoconferencia" component={Player} />
                    <Route path="/detalhe-turma/:turma/vconf/:vconfid/player-videoconferencia-aguardar" component={Player} />
                    <Route path="/detalhe-turma/:turma/vconf/:vconfid/player-video" component={Player} />
                    <Route path="/detalhe-turma/:turma/vconf/:vconfid/player-video-meets" component={Player} />
                    {/***************ROUTING PLAYERS***************/}
                </Switch>
                <div style={{ height: 220 }}></div>
                <Footer redessociais={redessociais} fundoBranco={fundoBranco} />
                <Popup />
            </div>
        );
    }
}

export default withRouter(Layout);
